import React from 'react';
import Image from 'next/image';

import { featureImg } from './images';
import { appleStore, googlePlay } from '@/images';
import Link from 'next/link';

const Feature = (): React.ReactNode => {
  return (
    <div className='bg-primary-foreground relative'>
      <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-6'>
        <div className='xl:px- bg-[#ef4444 relative isolate flex flex-col justify-between overflow-hidden rounded-xl pt-10 md:flex-row md:py-10 lg:py-16'>
          <div className='relative z-10 mx-auto flex flex-col items-start justify-center text-center md:mx-0 md:w-[50%] md:text-left lg:w-[40%]'>
            <h2 className='mx-auto text-3xl font-semibold tracking-tight text-white/80 md:mx-0 md:leading-[42px] lg:leading-[56px] xl:text-4xl'>
              Got an Event?
            </h2>
            <h3 className='poppins mx-auto text-4xl/10 font-bold text-white sm:mt-0 sm:text-5xl/14 md:mx-0 xl:text-6xl/18 !leading-12 lg:!leading-15'>
              Greet Got You Covered
            </h3>
            <p className='mt-6 text-sm/6 font-semibold tracking-wider text-pretty text-zinc-100 sm:font-medium xl:text-base/8'>
              List your event today and experience the Greet advantage. Our
              user-friendly platform offers a range of features, including all
              your poster designing, on demand settlements and dedicated
              relationship manager. Trust us on this. Once you try Greet,
              you&apos;ll never look back.
            </p>
            <div className='mt-4 md:mt-2 xs:flex-row flex w-full flex-col items-center justify-center gap-4 pb-12 md:justify-start md:pb-0'>
              <Link href="https://play.google.com/store/apps/details?id=com.fydo.eventorganiser&hl=en_IN&pli=1" target='_blank'>
                <Image
                  src={googlePlay}
                  alt='Download from Google Play'
                  className='mt-2 h-12 w-auto sm:mt-8 lg:h-14'
                />
              </Link>
              <Link href="https://apps.apple.com/in/app/greet-your-ticketing-partner/id6478972090" target='_blank'>
                <Image
                  src={appleStore}
                  alt='Download from App Store'
                  className='mt-2 h-12 w-auto sm:mt-8 lg:h-14'
                />
              </Link>
            </div>
          </div>
          <div className='relative flex w-[40%] flex-row justify-center gap-4 lg:w-[50%]'>
            <div className='absolute top-10 left-0 lg:top-20'>
              <Image
                alt='Feature logo screenshot'
                aria-label='Feature logo screenshot'
                src={featureImg}
                width={34}
                height={340}
                priority
                loading='eager'
                sizes='(max-width: 640px) 200px, 300px'
                className='w-[18rem] max-w-none rounded-md lg:w-[14rem] xl:w-[16rem]'
              />
            </div>
            <div className='absolute top-0 left-58 hidden md:-top-64 lg:block xl:left-66'>
              <Image
                alt='App screenshot 1'
                aria-label='App screenshot 1'
                src={featureImg}
                width={34}
                height={340}
                priority
                loading='eager'
                sizes='(max-width: 640px) 200px, 300px'
                className='w-[12rem] max-w-none rounded-md lg:w-[14rem] xl:w-[16rem]'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
